import axios from 'axios';

const API_SYNC_BASE_URL = process.env.REACT_APP_TRADEPLUS_SYNC_URL;
const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;

export const getCampaignProducts = async (
  campaignCode,
  page = 1,
  size = 10,
  collectionId,
  brandCampaignId,
  searchTerm
) => {
  try {
    const params = new URLSearchParams({
      campaignCode,
      page,
      size,
    });

    if (collectionId) params.append("collectionId", collectionId);
    if (brandCampaignId) params.append("brandCampaignId", brandCampaignId);
    if (searchTerm) params.append("searchTerm", searchTerm);

    const res = await axios.get(`${API_SYNC_BASE_URL}/products?${params.toString()}`);

    const items = Array.isArray(res.data) ? res.data : res.data.items || [];

    return {
      items,
      currentPage: res.data.currentPage || page,
      hasNextPage:
        typeof res.data.hasNextPage === "boolean"
          ? res.data.hasNextPage
          : items.length === size,
    };
  } catch (err) {
    const backendMessage = err?.response?.data;

    if (
      err?.response?.status === 404 &&
      typeof backendMessage === "string" &&
      backendMessage.includes("No products found")
    ) {
      return {
        items: [],
        currentPage: page,
        hasNextPage: false,
        message: "No products found for this campaign",
      };
    }

    throw err;
  }
};





export const getCollectionSKU = async (
  campaignCode,
  collectionId,
  page = 1,
  size = 10,
  searchTerm
) => {
  try {
    // Build query params dynamically
    const params = new URLSearchParams({
      campaignCode,
      page,
      size,
    });

    if (collectionId) {
      params.append("collectionId", collectionId);
    }
    if (searchTerm) {
      params.append("searchTerm", searchTerm);
    }

    const res = await axios.get(`${API_SYNC_BASE_URL}/by-collection?${params.toString()}`);

    const items = res.data.items || [];
    return {
      items,
      hasNextPage: items.length === size,
      currentPage: page,
    };
  } catch (err) {
    const backendMessage = err?.response?.data;

    if (
      err?.response?.status === 404 &&
      typeof backendMessage === "string" &&
      backendMessage.includes("No products found")
    ) {
      return {
        items: [],
        hasNextPage: false,
        currentPage: page,
        message: "No products found for this collection",
      };
    }

    throw err;
  }
};

// Fetch collections
export const fetchCollections = async () => {
  const res = await axios.get(`${API_BASE_URL}/Product/collections`); // adjust if different
  return res.data;
};

export const productService = {
  getBrandCampaigns: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/Product/brand-campaigns`, {
      params,
    });
    return response.data;
  },
};


